<rds-visual-card
  class="rds-shadow-2"
  [appStoryblok]="_editable()"
  (keydown.enter)="navigate()"
>
  @if(image()?.filename) {
  <img
    rds-card-image
    [src]="image().filename"
    [alt]="image().alt || 'Feature image for ' + image().title"
  />
  } @if(label()) {
  <rds-card-label>{{ label() }}</rds-card-label>
  }
  <rds-card-header>
    @if(overline()) {
    <rds-card-overline>{{ overline() }}</rds-card-overline>
    }
    <rds-card-title>{{ title() }}</rds-card-title>
  </rds-card-header>
  <rds-card-content>
    <p>
      {{ description() }}
    </p>
  </rds-card-content>
  <button
    rds-secondary-button
    size="s"
    [routerLink]="buttonLink()"
    [attr.aria-label]="buttonTitle()"
    tabindex="-1"
  >
    {{ buttonTitle() }}
  </button>
</rds-visual-card>
